import React from 'react';
import { useSelector } from 'react-redux';
import { IFilterAllData } from 'src/typings/filter';
import { getCrmData } from 'src/store/app/selectors';
import { CRMNames } from 'src/typings/app';
import { IBitrixDealPlacement } from 'src/store/crosstable/reducer';
import { Response } from 'src/api/hydraResponse';
import { AmoDeal } from './amo';
import { BitrixDeal } from './bitrix';
import { CreatioDeal } from './creatio';
import { NetHuntDeal } from './netHunt';

export interface IApartmentConnectDeal {
  placeInfo?: IFilterAllData;
  isSmall?: boolean,
  showDealDetails?: boolean,
  onLoading?: (isLoading: boolean) => void
  // Single-fetch mode: the sidebar owns the one placement request per selected
  // unit (it also drives the skeleton) and shares the result down. Without
  // these props BitrixDeal self-fetches (legacy standalone contexts).
  placementDeal?: IBitrixDealPlacement;
  refreshPlacementDeal?: (placementId: string | null) => Promise<Response<IBitrixDealPlacement>>;
  updatePlacementDeal?: (data?: IBitrixDealPlacement) => void;
  // The unit this widget instance is about. Defaults to the store's selected
  // apartment — hover popovers (Floors/3D polygons) MUST pass their own unit,
  // the store selection there is stale.
  unitId?: string;
}

// The legacy CRM components (amo/creatio/netHunt) still read the grid row
// directly; bitrix works from the store alone. Narrow the shared props for
// them until placeInfo is phased out everywhere.
export type IApartmentConnectDealWithPlacement = IApartmentConnectDeal & {
  placeInfo: IFilterAllData;
};

export const ApartmentConnectDeal: React.FC<IApartmentConnectDeal> = React.memo(({
  placeInfo,
  isSmall,
  showDealDetails,
  onLoading,
  placementDeal,
  refreshPlacementDeal,
  updatePlacementDeal,
  unitId,
}) => {
  const crmData = useSelector(getCrmData);
  if (!crmData) {
    return null;
  }

  switch (crmData.crm) {
    case CRMNames.amocrm:
      return placeInfo ? <AmoDeal placeInfo={placeInfo} isSmall={isSmall} /> : null;

    case CRMNames.bitrix:
      return (
        <BitrixDeal
          showDealDetails={showDealDetails}
          onLoading={onLoading}
          placementDeal={placementDeal}
          refreshPlacementDeal={refreshPlacementDeal}
          updatePlacementDeal={updatePlacementDeal}
          unitId={unitId}
        />
      );

    case CRMNames.creatio:
      return placeInfo ? <CreatioDeal placeInfo={placeInfo} isSmall={isSmall} /> : null;

    case CRMNames.netHunt:
      return placeInfo ? <NetHuntDeal placeInfo={placeInfo} isSmall={isSmall} /> : null;

    default:
      return null;
  }
});
